<template>
  <div>
    <div class="router-header flex flex-wrap items-left mb-3">
      <div
        class="content-area__heading pr-4"
      >
        <h4 class="mb-1">
          {{ $t("endorsementInvite.progressMeasure.pm1") }}
        </h4>
        <div class="mt-2 mb-1">
          {{ $t("endorsementInvite.progressMeasure.pm2") }}
        </div>
      </div>
    </div>
    <div class="vx-row mb-base">
      <div
        v-for="(pm, indexp) in progress_measures_list"
        :key="indexp"
        class="vx-col w-full"
      >
        <div
          :class="{ 'bg-primary': your_progress_measures.includes(pm.pmId),selected: your_progress_measures.includes(pm.pmId) }"
          @click="storeProgressMeasure(pm.pmId)"
          class="vx-card overflow-hidden mb-2"
        >
          <!---->
          <div class="vx-card__collapsible-content vs-con-loading__container">
            <div>
              <div class="p-6 flex items-center">
                <span
                  class="p-3 inline-flex rounded-full feather-icon select-none relative text-primary mc-icon"
                  style="background: rgba(var(--vs-primary),0.15);"
                >
                  <img
                    :src="require('@/assets/Iconography/Progress measures/PM_' + (parseInt(indexp) + 1) + '.svg')"
                    alt="pm"
                    width="30px"
                    height="30px"
                  />
                </span>
                <div class="truncate items-left" style="line-height: 1.5;">
                  <!-- Render Title if it exists in the dictionary -->
                  <h5 v-if="pm.title" class="font-bold mb-1" style="font-weight: 700; color: inherit;">
                    {{ pm.title }}
                  </h5>
                  <span class="mb-1">
                    {{ pm.pmMap }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Store Module
// import moduleEndorsementInvite from "@/store/add-skill/moduleCompetencyProgress.js";
// import ccd from "@/assets/data/charactersistic-competency-definition.js";

export default {
  name: "ProgressMeasure",
  data() {
    return {
      progress_measures_list: [],
      custom_progress_measures: [],
      your_progress_measures: [],
      CCD: this.$t("addNewSkill.data")
    };
  },
  created() {
    const id = this.$route.params.traineeCompetenciesId;
    // Replace the trainee-competencies-prgms/find block inside created():
this.$store
  .dispatch("trainee-competencies-prgms/find", {
    query: { traineeCompetenciesId: id }
  })
  .then(res3 => {
    for (const pm in res3.data) {
      if(res3.data[pm].progressMeasureId.includes('custom')) {
        this.progress_measures_list.push({
          id: res3.data[pm].progressMeasureId,
          pmId: res3.data[pm].progressMeasureId,
          pm: res3.data[pm].progressMeasure,
          pmMap: res3.data[pm].progressMeasure,
          title: "" // Custom items have no predefined titles
        })
      } else {
        const s = (res3.data[pm].progressMeasureId).split("-")
        const charId = s[0]
        const compId = s[1]
        const pmsId = s[2]
        console.log(charId, compId, pmsId)
        
        const charObj = this.CCD[charId] || {};
        const compList = charObj.competencies || {};
        const compObj = compList[compId] || {};
        const pmList = compObj.progressMeasures || {};
        const targetPm = pmList[pmsId] || {};

        this.progress_measures_list.push({
          id: pmsId,
          pmId: targetPm.id || res3.data[pm].progressMeasureId,
          pm: targetPm.pm || "Progress measure unavailable",
          pmMap: targetPm.pmMap || "Progress measure map unavailable",
          title: targetPm.title || "" // Capture the title here
        })
      }
    }
  })
      .catch(err3 => {
        console.log("could not find progress measure", err3);
      });
  },
  methods: {
    getAllProgressMeasures(){
      for(let i in this.PM){
        console.log(i)
      }
    },
    storeProgressMeasure(pm) {
      if(this.your_progress_measures.includes(pm)){
        this.$store
          .dispatch("endorsementInvite/removeProgressMeasure", pm)
          .then(res => {
            console.log("store add pm", this.$store.state.endorsementInvite.progressMeasures);
            this.your_progress_measures = this.$store.state.endorsementInvite.progressMeasures || [];
          })
          .catch(err => {
            console.log("could not remove progress measure", err);
          });
      }
      else{
        this.$store
          .dispatch("endorsementInvite/addProgressMeasure", pm)
          .then(res => {
            this.your_progress_measures = this.$store.state.endorsementInvite.progressMeasures || [];
          })
          .catch(err => {
            console.log("could not add progress measure", err);
          });
      }
    }
  },
  components: {},
  mounted() {}
};
</script>

<style scoped>
.vx-card {
  cursor: pointer;
}

.vx-card:hover {
  background: #F9F9F9;
}
.competency-img {
  width: 30px;
  height: 30px;
  margin: auto;
}

.selected > .truncate > span {
  color: white !important;
}

.vx-card .vx-card__collapsible-content {
  -webkit-transition: none !important;
  transition: none !important;
}

.selected {
  color: white! important;
}

.selected span.mc-icon {
  background: white !important;
}

.not-selected-competency {
}

/*.con-vs-card {
      margin-bottom: 0.4rem;
      !*-webkit-box-shadow: none;
        box-shadow: none;*!
      min-height: 79px;
    }*/

.con-vs-card >>> .vs-card--content {
  padding: 3px 8px 3px 8px !important;
  margin-bottom: 10px;
}

.truncate {
  width: 80%;
  white-space: normal !important;
  margin-left: 1.5rem;
}

.items-left{
  text-align: left;
  text-align: -moz-left;
  text-align: -webkit-left;
}
</style>
